import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  Input,
  useFormField,
} from "@shortsworks/ui";
import { FormItemProps } from "@app/components/forms/types/props";
import { cn } from "@shortsworks/ui/lib/utils";
import {
  EmailInputSchema,
  PasswordInputSchema,
  TextInputSchema,
  UrlInputSchema,
} from "@app/components/forms/types/schema";
import { useForm } from "react-hook-form";

export const FormPassword = ({
  form,
  schema,
  ...rest
}: FormItemProps<PasswordInputSchema>) => {
  return (
    <FormField
      control={form.control}
      name={schema.id}
      render={({ field, _, formState }: any) => (
        <FormItem
          className={cn(
            schema.appearance?.className,
            schema.appearance?.border ? "border p-3 rounded-lg shadow-sm" : "",
            schema.behavior?.hidden && "hidden",
          )}
        >
          <FormLabel>
            {typeof schema.label === "function"
              ? schema.label(form.getValues(), formState)
              : schema.label}
          </FormLabel>
          <FormControl>
            <Input
              type="password"
              placeholder={schema.placeholder}
              {...field}
              {...schema.behavior}
            />
          </FormControl>
          {schema.description && (
            <FormDescription>
              {typeof schema.description === "function"
                ? schema.description(form.getValues())
                : schema.description}
            </FormDescription>
          )}
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
